// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"GamePageSnackbar__snackbar___1pgyu","closeButton":"GamePageSnackbar__closeButton___1Nrd2"};